export default __webpack_public_path__ + "static/fig-6f60524b4c1de047d76e7642519f484c.png";